import styled from '@emotion/styled/macro'

import mediaQuery from 'share/utils/mediaQuery'
import { StyledCard, StyledCardFooter } from 'components/atoms/StyledCard'

const CoursesProviderInfoText = styled('p')`
  margin-bottom: 24px;
`

const CoursesProviderCardsWrapper = styled('div')`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;

  > ${StyledCard} {
    :not(:first-of-type) {
      margin-top: 24px;
    }

    ${StyledCardFooter} {
      button {
        width: 100%;

        :last-of-type {
          margin-top: 8px;
        }
      }
    }

    ${mediaQuery('', 'tablet')} {
      flex-basis: calc(50% - 8px);

      :nth-of-type(even) {
        margin-left: 16px;
      }

      :nth-of-type(-n + 2) {
        margin-top: 0;
      }
    }
  }
`

const CoursesProviderFooter = styled('div')`
  color: var(--CINight);
  font-size: 0.8rem;

  > :last-child {
    margin-bottom: 0;
  }

  .ui-courses-footer-button-as-link {
    border: none;
    box-shadow: none;
    color: var(--skydiver);
    font-size: 0.8rem;
    margin: 0;
    outline: none;
    padding: 0;
    text-decoration: none;
  }
`

export {
  CoursesProviderCardsWrapper,
  CoursesProviderFooter,
  CoursesProviderInfoText
}
